<script>
export default {
  name: "letterInCircle",
  props: {
    borderColor: {
      type: String,
      default: '#010101'
    },
    textColor: {
      type: String,
      default: '#010101'
    },
    backgroundColor: {
      type: String,
      default: '#ffff'
    }
  },
  data() {
    return {

    }
  }
}
</script>

<template>
  <div class="circle-wrapper user-select-none">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 500 500">

      <g id="UrTavla">
          <circle style="stroke-width:7;stroke-miterlimit:10;" :style="{stroke: borderColor, fill: backgroundColor}" cx="250" cy="250"
                  r="245">

          </circle>

        <text x="50%" y="50%" :fill="textColor" text-anchor="middle" stroke-width="1px" dy=".3em"
              font-size="25em"><slot></slot></text>
      </g>
    </svg>
  </div>
</template>

<style scoped>
.circle-wrapper {
  cursor: pointer;

}
</style>
